import SnackbarEvent from '@/events/SnackbarEvent';
import api from '@/services/api-recebimentoweb';
import { SetupWebSocket, WSDefaultRoute, CloseWebSocket } from './ws/websocket';
import conexao from './userlogin';
import { SetupEnvioLocal } from './atualizalocal';

let online = typeof navigator !== 'undefined' ? navigator.onLine : true;
let jaDefinido = false;

export async function testarConexaoApi() {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return false;
  }
  try {
    const res = await api.get('/', { timeout: 4000 });
    return !!(res && (res.status === 200 || res.data));
  } catch (err) {
    if (err.response && (err.response.status === 401 || err.response.status === 403 || err.response.status === 200)) {
      return true;
    }
    return false;
  }
}

export async function IsOnline() {
  if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
    online = navigator.onLine;
  }
  return online;
}

let isSyncing = false;

export async function sincronizarSilencioso() {
  if (isSyncing || typeof navigator === 'undefined' || !navigator.onLine) {
    return;
  }
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
    return;
  }
  try {
    isSyncing = true;
    await SetupEnvioLocal({ silent: true });
  } catch (e) {
    console.warn('Sincronização em background falhou:', e);
  } finally {
    isSyncing = false;
  }
}

export function SetupIsOnline() {
  if (!jaDefinido) {
    const handleOffline = () => {
      if (online !== false) {
        console.log('Atualmente Offline');
        online = false;
        CloseWebSocket();
        document.dispatchEvent(new SnackbarEvent({
          message: 'Sem conexão com a internet. O aplicativo está em modo offline.',
        }));
      }
    };

    const handleOnline = async () => {
      if (online !== true) {
        console.log('Atualmente Online');
        online = true;
        document.dispatchEvent(new SnackbarEvent({
          message: 'Conexão com a internet restabelecida!',
        }));
        try {
          // A ordem importa: WSDefaultRoute resolve a URL do WS em producao e
          // conexao() repoe o auth:token quando o login foi feito offline. Se o
          // SetupWebSocket vier antes, o ciclo de sync (novoid -> enviaDataAtt)
          // comeca sem token e nada sincroniza.
          await WSDefaultRoute();
          await conexao();

          await SetupEnvioLocal();
          SetupWebSocket();
        } catch (e) {
          console.error('Erro durante resincronização ao voltar online:', e);
        }
      }
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    window.addEventListener('focus', () => {
      if (typeof navigator !== 'undefined' && navigator.onLine) {
        if (!online) {
          handleOnline();
        }
      } else if (typeof navigator !== 'undefined' && !navigator.onLine) {
        if (online) {
          handleOffline();
        }
      }
    });

    // Verificação periódica leve (heartbeat) a cada 6 segundos
    setInterval(() => {
      if (typeof navigator !== 'undefined') {
        const estadoAtual = navigator.onLine;
        if (estadoAtual && !online) {
          handleOnline();
        } else if (!estadoAtual && online) {
          handleOffline();
        }
      }
    }, 6000);

    // Sincronização automática em background a cada 60 segundos (apenas se online e aba visível)
    setInterval(() => {
      sincronizarSilencioso();
    }, 60000);

    jaDefinido = true;
  }
}
